import { AccordionComponent, AccordionProps } from './accordion';
import styles from './accordion-list.module.scss';

interface AccordionListProps {
  items: AccordionProps[];
}

export const AccordionList = ({ items }: AccordionListProps): JSX.Element => {
  return (
    <ul className={styles.AccordionList}>
      {items.map((item, index) => (
        <li key={index} className={styles.ListItem}>
          <AccordionComponent {...item} />
        </li>
      ))}
    </ul>
  );
};
